const colors = {
  primaryColor: "#007293",
  secondaryColor: "#E7EAEE",
  Neutral: {
    Neutral0: "#FFFFFF",
    Neutral50: "#F4F2F1",
    Neutral100: "#F0E9E6",
    Neutral200: "#D8D7D4",
    Neutral300: "#AFA5A1",
    Neutral400: "#8A7B75",
    Neutral500: "#635954",
    Neutral600: "#4E4846",
    Neutral700: "#3D3A38",
    Neutral800: "#252322",
    Neutral900: "#000000"
  },
  Red: {
    Red50: "#fff2f0",
    Red100: "#ffdcd6",
    Red200: "#ffb6ad",
    Red300: "#ff8d85",
    Red400: "#ff615c",
    Red500: "#ff3232",
    Red600: "#d92127",
    Red700: "#b3121d",
    Red800: "#8c0714",
    Red900: "#660411"
  },
  Orange: {
    Orange50: "#fff8f0",
    Orange100: "#ffe3c7",
    Orange200: "#ffcb9e",
    Orange300: "#ffb175",
    Orange400: "#ff944d",
    Orange500: "#ff7223",
    Orange600: "#d95514",
    Orange700: "#b33b07",
    Orange800: "#8c2500",
    Orange900: "#661800"
  },
  Yellow: {
    Yellow50: "#fffcf0",
    Yellow100: "#fff7d9",
    Yellow200: "#ffebb0",
    Yellow300: "#ffdd87",
    Yellow400: "#ffcc5e",
    Yellow500: "#ffb835",
    Yellow600: "#d99323",
    Yellow700: "#b37014",
    Yellow800: "#8c5108",
    Yellow900: "#663705"
  },
  Green: {
    Green50: "#F0F7EA",
    Green100: "#D1E7BF",
    Green200: "#BBDBA0",
    Green300: "#9CCA74",
    Green400: "#89C059",
    Green500: "#6BB030",
    Green600: "#61A02C",
    Green700: "#4C7D22",
    Green800: "#426E1C",
    Green900: "#2D4A14"
  },
  Teal: {
    Teal50: "#CCE5DD",
    Teal100: "#B4CCC4",
    Teal200: "#8FB3A7",
    Teal300: "#5F9E8E",
    Teal400: "#31A387",
    Teal500: "#06937E",
    Teal600: "#058673",
    Teal700: "#00614F",
    Teal800: "#035145",
    Teal900: "#033E35"
  },
  Blue: {
    Blue50: "#E9F0F5",
    Blue100: "#99ADC0",
    Blue200: "#686B8C",
    Blue300: "#35467A",
    Blue400: "#1F4370",
    Blue500: "#002F61",
    Blue600: "#002B58",
    Blue700: "#002145",
    Blue800: "#001137",
    Blue900: "#000A21"
  },
  Turquoise: {
    Turquoise50: "#E9F2F9",
    Turquoise100: "#C5D8E5",
    Turquoise200: "#9DB9CF",
    Turquoise300: "#799CB6",
    Turquoise400: "#4590AD",
    Turquoise500: "#007293",
    Turquoise600: "#006886",
    Turquoise700: "#005670",
    Turquoise800: "#003F51",
    Turquoise900: "#00303E"
  },
  Shadow: {
    Shadow0: "#1A18171A",
    Shadow10: "#1A18170D"
  },
  Pink: {
    Pink50: "#fff0f6",
    Pink100: "#ffd6e7",
    Pink200: "#ffadd2",
    Pink300: "#ff85c0",
    Pink400: "#f759ab",
    Pink500: "#eb2f96",
    Pink600: "#c41d7f",
    Pink700: "#9e1068",
    Pink800: "#780650",
    Pink900: "#520339"
  },
  Purple: {
    Purple50: "#F9F5FF",
    Purple100: "#D9C8FC",
    Purple200: "#B5A1F0",
    Purple300: "#9779E6",
    Purple400: "#7C52DD",
    Purple500: "#6231D2",
    Purple600: "#421CB1",
    Purple700: "#2E108A",
    Purple800: "#210865",
    Purple900: "#120338"
  },
  Cyan: {
    Cyan50: "#E6FAFC",
    Cyan100: "#C4EFF5",
    Cyan200: "#A2E3F0",
    Cyan300: "#74D3E3",
    Cyan400: "#51C3D6",
    Cyan500: "#31A8C7",
    Cyan600: "#06879E",
    Cyan700: "#056173",
    Cyan800: "#034D57",
    Cyan900: "#023135"
  }
};

export default colors;
